export const getDecimalsForToken = (tokenName: string): number | undefined => {
  if (tokenName === 'MATIC_USDT') return 6;
  if (tokenName === 'MATIC_MATIC') return 18;
};
